<template>
  <section
    class="offers_section"
    :style="paddingCalculator"
    :class="$store.getters['main/getBackgroundTone'](evenOdd)"
  >
    <div class="container">
      <div
        class="offers_head flex-box between"
        v-if="_.get(contentData, `conf.header.title`)"
      >
        <h3 class="offers_ttl tbc-medium font-38">
          {{ _.get(contentData, `conf.header.title`) }}
        </h3>
        <router-link
          class="font-16 tbc-medium"
          v-if="_.get(contentData, `conf.header.full_list_url`)"
          :to="_.get(contentData, `conf.header.full_list_url`)"
          >{{ _.get(contentData, `conf.header.full_list_title`) }}</router-link
        >
      </div>
      <div class="offers_slider-container">
        <swiper
          ref="mainSlider"
          class="offers_slider grab"
          :options="swiperOptions"
        >
          <swiper-slide
            v-for="(offer, index) in _.get(contentData, 'data.list')"
            :key="index"
          >
            <router-link :to="$store.getters['main/getSingleUrl'](offer)">
              <offer-card-with-image
                :contentData="contentData"
                :offer="offer"
              />
            </router-link>
          </swiper-slide>
          <div class="swiper-scrollbar" slot="scrollbar">
            <div
              class="swiper-scrollbar-drag"
              style="width: 30%"
              slot="scrollbar"
            ></div>
          </div>
        </swiper>

        <div class="slider_buttons container">
          <div class="slider_button-prev" slot="button-prev">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                transform="translate(0 0)"
                fill="#575757"
              />
            </svg>
          </div>
          <div class="slider_button-next" slot="button-next">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                transform="translate(0 0)"
                fill="#575757"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import paddingCalculator from "../../mixins/paddingMixin";
import OfferCardWithImage from "./OfferCardWithImage.vue";

export default {
  props: ["contentData", "evenOdd"],
  mixins: [paddingCalculator],
  components: {
    OfferCardWithImage
  },

  data() {
    return {
      swiperOptions: {
        spaceBetween: 30,
        slidesPerView: 2,
        speed: 800,
        watchOverflow: true,
        updateOnWindowResize: true,

        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
          dragSize: 300
        },
        navigation: {
          nextEl: ".slider_button-next",
          prevEl: ".slider_button-prev"
        },

        breakpoints: {
          320: {
            slidesPerView: 1.1,
            scrollbar: {
              dragSize: 129
            }
          },
          480: {
            spaceBetween: 20,
            slidesPerView: 1.5,
            scrollbar: {
              dragSize: 176
            }
          },
          768: {
            spaceBetween: 20,
            slidesPerView: 2
          },
          1024: {
            spaceBetween: 30,
            slidesPerView: 2
          }
        },
        touchStartPreventDefault: false,

        on: {
          touchMove() {
            document
              .querySelectorAll(".offers_slider .swiper-slide")
              .forEach(slide => {
                slide.style.transform = "scale(0.90, 0.90)";
              });
          },
          touchEnd() {
            document
              .querySelectorAll(".offers_slider .swiper-slide")
              .forEach(slide => {
                slide.style.transform = "scale(1, 1)";
              });
          }
        }
      }
    };
  }
};
</script>

<style scoped>
.offers_section {
  overflow: hidden;
}
.offers_ttl {
  color: #dadada;
  margin-right: 20px;
}
.offers_head {
  margin-bottom: 48px;
}
.offers_head a {
  margin-top: 6px;
  color: #00aeef;
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: 0.6s;
  white-space: nowrap;
}
.offers_slider-container {
  position: relative;
}
.swiper-container {
  overflow: visible;
}
.offers_slider .swiper-slide {
  -webkit-tap-highlight-color: transparent;
  transition: 0.5s;
  height: unset;
}
.swiper-container-horizontal > .swiper-scrollbar {
  width: 88%;
}
.swiper-scrollbar {
  background-color: #364756;
  height: 2px !important;
}
.swiper-scrollbar-drag {
  top: -1px;
  background: linear-gradient(
    to right,
    #26dffe 0%,
    #21cdf5 30%,
    #0dbff4 75%,
    #00aeef 100%
  );
  height: 4px;
  cursor: pointer;
}
.slider_buttons {
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  bottom: 10px;
  z-index: 9;
  position: relative;
  margin-left: auto;
  margin-right: 0;
}
.slider_button-prev {
  margin-right: 32px;
}
.slider_button-prev svg {
  transform: rotate(180deg);
}
.slider_buttons .slider_button-prev,
.slider_buttons .slider_button-next {
  cursor: pointer;
  transition: 0.4s;
}
.slider_button-prev svg,
.slider_button-next svg {
  transition: 0.6s;
}
.slider_button-prev svg path,
.slider_button-next svg path {
  transition: 0.6s;
  fill: #6c7a8a;
}
.slider_buttons .slider_button-prev:hover svg path,
.slider_buttons .slider_button-next:hover svg path {
  fill: #00aeef;
}

.slider_buttons .swiper-button-disabled svg path {
  /* fill: #c6c6c6; */
}
.slider_buttons .swiper-button-disabled:hover svg path {
  fill: #c6c6c6;
}

@media (max-width: 1439px) {
  .swiper-container-horizontal > .swiper-scrollbar {
    width: 70%;
  }
}

@media (max-width: 1023px) {
  .offers_ttl.font-38 {
    font-size: 28px;
    line-height: 38px;
  }
}

@media (max-width: 767px) {
  .offers_head a {
    margin-top: 0;
    display: flex;
    align-items: center;
  }
  .offers_head {
    display: grid;
    gap: 10px;
  }
  /* .swiper-scrollbar-drag {
    width: 100px !important;
  } */
}
</style>

<style>
.offers_slider-container .swiper-wrapper {
  padding-bottom: 89px;
}
</style>
